module.exports = __webpack_public_path__ + "img/357b990.jpg";